import { useCallback, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';
import {
  getOrchestratorNid,
  getSelectedResponse,
  getEditorStatus,
  getEditorComment,
  setEditorPayload,
} from '@domains/orchestrator-pricing-committee/store/slices/domainOrchestratorPricingCommittee.slice';
import { useSelectedWorkflowStep } from '@domains/orchestrator-pricing-committee/hooks/useSelectedWorkflowStep';
import { useCurrentOrchestrator } from '@domains/orchestrator-pricing-committee/hooks/useCurrentOrchestrator';
import { useJsonEditor } from '@domains/orchestrator-pricing-committee/components/ModalOrchestratorSupportTool/hooks/useJsonEditor';

export const JSONEditor = () => {
  const { step } = useSelectedWorkflowStep();
  const { currentOrchestrator } = useCurrentOrchestrator();
  const nid = useSelector(getOrchestratorNid);
  const country = useSelector(getCountry);
  const selectedResponse = useSelector(getSelectedResponse);
  const editorStatus = useSelector(getEditorStatus);
  const editorComment = useSelector(getEditorComment);
  const dispatch = useDispatch();

  const handleChange = useCallback(
    (updated: Record<string, unknown>) => {
      dispatch(setEditorPayload(updated));
    },
    [dispatch],
  );

  const { containerRef, setExternalJson } = useJsonEditor({ onChange: handleChange });

  /** Reconstruye el objeto cuando cambian los datos externos */
  useEffect(() => {
    if (!step) return;

    const owner =
      (step.responses?.[selectedResponse]?.detail as { owner_process?: string })
        ?.owner_process ?? '';

    const payload = {
      nid,
      country: country ?? '',
      event_name: step.name,
      status: editorStatus,
      workflow_alias: currentOrchestrator?.data?.workflow_alias || '',
      response: {
        owner_process: owner,
        comment: editorComment,
      },
    } as Record<string, unknown>;

    setExternalJson(payload);
    dispatch(setEditorPayload(payload));
  }, [
    nid,
    country,
    step,
    selectedResponse,
    editorStatus,
    editorComment,
    currentOrchestrator,
    setExternalJson,
    dispatch,
  ]);

  if (!step) return null;

  return (
    <div data-testid="json-editor-container">
      <div ref={containerRef} style={{ height: '400px' }} />
    </div>
  );
};
